import React from 'react';
import { ArrowPathIcon, CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface LoadingStateProps {
  isLoading: boolean;
  message?: string;
  success?: boolean;
  error?: string;
  showProgress?: boolean;
  progress?: number;
}

export function LoadingState({ 
  isLoading, 
  message = 'Loading...', 
  success = false, 
  error,
  showProgress = false,
  progress = 0
}: LoadingStateProps) {
  if (!isLoading && !success && !error) return null;

  return (
    <div className="flex flex-col items-center justify-center py-8 px-4">
      <div className="relative">
        {isLoading && (
          <ArrowPathIcon className="w-8 h-8 text-purple-600 animate-spin" />
        )}
        {success && (
          <CheckCircleIcon className="w-8 h-8 text-green-600" />
        )}
        {error && (
          <ExclamationTriangleIcon className="w-8 h-8 text-red-600" />
        )}
      </div>

      <div className="mt-4 text-center">
        <p className="text-sm font-medium text-gray-900 mb-1">
          {isLoading && message}
          {success && 'Success!'}
          {error && 'Error occurred'}
        </p>
        
        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}

        {showProgress && isLoading && (
          <div className="mt-3 w-full max-w-xs">
            <div className="bg-gray-200 rounded-full h-2">
              <div 
                className="bg-purple-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              {Math.round(progress)}% complete
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
